import {HTMLAttributes, JSXElementConstructor, ReactElement, ReactNode, useId} from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./tooltip-trigger-view.scss";
import {Placement} from "react-bootstrap/types";
//<editor-fold desc="Props">
export interface TooltipTriggerProps extends HTMLAttributes<HTMLDivElement> {
  tipKey: string;
  tip?: string|ReactNode;
  tipClass?: string;
  wrapDisabled?: boolean;
  children: ReactElement<any, string | JSXElementConstructor<any>>;
  placement?: Placement;
  delay?: number | { show: number; hide: number };
}
//</editor-fold>

function TooltipTrigger(props: TooltipTriggerProps) {
  const {
    tipKey,
    tip,
    wrapDisabled,
    children,
    placement,
    className,
    tipClass,
    delay,
  } = props;
  const idPrefix = useId();
  let rDelay = delay || { show: 300, hide: 100 };
  return (
    <>
      {tip && (
        <OverlayTrigger
          delay={rDelay}
          placement={placement || "auto"}
          key={tipKey}
          overlay={
            <Tooltip className={tipClass} id={idPrefix + tipKey + `-tip`}>
              {tip}
            </Tooltip>
          }
          popperConfig={{
            modifiers: [
              {
                name: "flip",
                options: {
                  boundary: "viewport",
                },
              },
              {
                name: "preventOverflow",
                options: {
                  boundariesElement: "viewport",
                  altAxis: true,
                },
              },
            ],
          }}
        >
          {(wrapDisabled ?
              <div className={"tooltip-disabled-wrapper " + (className || "")}>
                {children}
              </div> :
              children
          )}
        </OverlayTrigger>
      )}
      {!tip && children}
    </>
  );
}
export default TooltipTrigger;
